/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Icon } from '@mui/material';
import { motion } from 'framer-motion';
import { ReactComponent as Spinner } from '../Images/spinner.svg';
import { verticalTimeline } from '../styles/verticalTimeline';
import DownArrow from './downArrow';
import { useAppSelector } from '../../store/hook';
import { usePrefersReducedAnimation } from '../../common/hooks/usePrefersReducedAnimation';
import { usePrefersReducedMotion } from '../../common/hooks/usePrefersReducedMotion';

const TransitionWrapper = ({ children }: any): React.JSX.Element => {
  const { reverseAnimation } = useAppSelector((state) => state.timeLine);
  const shouldReduceMotion = usePrefersReducedMotion();

  if (shouldReduceMotion) return <div>{children}</div>;

  return (
    <motion.div
      animate={{ opacity: 1, y: 0 }}
      initial={{ opacity: 1, y: reverseAnimation ? -510 : 510 }}
      exit={{ opacity: 0.2, y: reverseAnimation ? 650 : -650 }}
      transition={{ duration: 1.0 }}>
      {children}
    </motion.div>
  );
};

const Transition = ({ children, isTrans = false, timelineStyles = null }: any): React.JSX.Element => {
  const {
    settings: {
      page: { timeline },
    },
  } = useAppSelector((state) => state.template);
  const { showSpinner } = useAppSelector((state) => state.timeLine);

  /**
   * STOP OR START animation as per system configurations of animation effects
   */
  usePrefersReducedAnimation();

  const { classes } = verticalTimeline(timelineStyles || timeline);

  return (
    <div style={{ overflow: 'hidden' }}>
      <TransitionWrapper>{children}</TransitionWrapper>
      {isTrans && (
        <TransitionWrapper>
          {!showSpinner && (
            <Icon className={classes.spinner}>
              <DownArrow timelineStyles={timelineStyles} />
            </Icon>
          )}
          {showSpinner ? (
            <Icon data-testid="loaderIcon" className={classes.spinner}>
              <Spinner className={classes.circle} />
            </Icon>
          ) : (
            <></>
          )}
        </TransitionWrapper>
      )}
    </div>
  );
};
export default Transition;
